import React, { Component } from "react";

export class CompanyInfo extends Component {
  render() {
    return (
      <div className="About-companyInfo-container">
        <div className="About-companyInfo-container-text">
          <h3>Who we are</h3>
        </div>
      </div>
    );
  }
}

export default CompanyInfo;
